import { z } from "zod/v4";
import { championEntrySchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export const champions = {
	list: (params?: { season?: number; ageCategory?: string }) => {
		const query = new URLSearchParams();
		if (params?.season) query.set("season", String(params.season));
		if (params?.ageCategory) query.set("ageCategory", params.ageCategory);
		const qs = query.toString();
		return fetchApi(`/champions${qs ? `?${qs}` : ""}`, z.array(championEntrySchema));
	},
};
